import {
  ORDER_STATUS_AWAITING_CREDIT_CHECK,
  ORDER_STATUS_AWAITING_ECC,
  ORDER_STATUS_CANCELLATION_IN_PROGRESS,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMMITTED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_DELAYED,
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_PARTIALLY_CANCELLED,
  ORDER_STATUS_PROVISIONING,
} from 'features/order-tracker/services/constants';

export const CONTACT_US_LINK = 'https://business.bt.com/help/home/';
export const CALL_US_LINK = 'https://business.bt.com/help/contact-us-business/';

interface OrderStatusMessageEntry {
  text: string;
  linkUrl?: string;
  linkText?: string;
  endText?: string;
}

export const ORDER_STATUS_MESSAGE: Record<string, OrderStatusMessageEntry> = {
  [ORDER_STATUS_IN_PROGRESS]: {
    text: "Your order is on track. We'll soon have an update and be in touch via SMS or email.",
  },
  [ORDER_STATUS_COMMITTED]: {
    text: "Your order is on track. We'll soon have an update and be in touch via SMS or email.",
  },
  [ORDER_STATUS_DELAYED]: {
    text: "Sorry, this order is delayed. But we'll soon have an update and be in touch via SMS or email.",
  },
  [ORDER_STATUS_CANCELLED]: {
    text: "This order's been cancelled, please chat now or ",
    linkUrl: CALL_US_LINK,
    linkText: 'call us',
    endText: ' if you need any further info.',
  },
  [ORDER_STATUS_COMPLETED]: {
    text: 'This order has been completed. If you have any questions about your service, please ',
    linkText: 'contact us.',
    linkUrl: CONTACT_US_LINK,
  },
  [ORDER_STATUS_CANCELLATION_IN_PROGRESS]: {
    text: "We're working on the cancellation requested for this order. It will be completed soon. We'll be in touch if necessary.",
  },
  [ORDER_STATUS_AWAITING_CREDIT_CHECK]: {
    text: 'This order is currently going through an additional credit check.',
  },
  [ORDER_STATUS_AWAITING_ECC]: {
    text: 'Some additional construction charges need signing off. So we can progress with this order, please chat now or ',
    linkText: 'call us.',
    linkUrl: CALL_US_LINK,
  },
  [ORDER_STATUS_PROVISIONING]: {
    text: "Your services and products you've ordered are now ready to use. Any final admin details will be with you shortly.",
  },
  [ORDER_STATUS_PARTIALLY_CANCELLED]: {
    text: "Sorry, we're currently resolving an issue with this order. We'll soon have an update and be in touch via SMS or email.",
  },
};
